import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: theme.palette.primary.main,
    },
    '& textarea': {
      minHeight: 80,
    },
  },
  alertTitle: {
    fontWeight: 'bold',
    fontSize: 14,
    paddingBottom: theme.spacing(0.5),
  },
  titleCell: {
    padding: '0px 16px 0px 0',
    fontSize: '13px',
    fontWeight: '800'
  },
  boldCell:{
    padding: '10px 16px 10px 16px',
    fontSize: '13px',
  },
  customCaptchaDialog: {
    display: 'flex',
    flexDirection: 'row-reverse',
    marginTop: '16px',
    paddingRight: '16px',
    gap: '15px',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  captchaDialog: {
    maxHeight: 37,
    maxWidth: '100%',
    borderRadius: 4,
    marginInlineStart: theme.spacing(1),
    marginTop: theme.spacing(3),
  },
  captchaLoadingDialog: {
    height: 68,
    width: 150,
    borderRadius: 4,
    marginInlineStart: theme.spacing(1),
    marginTop: 10,
  },
  captchaBoxDialog: {
    display: 'flex',
    alignItems: 'center',
  },
  iconActionCaptchaDialog: {
    marginTop: 12,
  },
}));

export const useStylesOldCreditTransfer = makeStyles((theme) => ({
  root: {
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: theme.palette.primary.main,
    },
    '& textarea': {
      minHeight: 80,
    },
  },
  card1: {
    marginBottom: 20,
    paddingBottom: 25,
  },
  currencyText: {
    fontSize: 15,
    paddingInlineStart: theme.spacing(1),
  },
  balanceBox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0.8),
    background: '#eceff1',
    border: '1px solid #2B3990',
    padding: theme.spacing(1.5),
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.09)',
    borderRadius: 8,
    backgroundImage: 'url(/images/riyal.svg)',
    backgroundPosition: '-19px center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 75%',
  },
  balanceTitle: {
    color: '#263238',
    fontSize: 14,
    fontWeight: 'bold',
  },
  balancePrice: {
    color: '#263238',
    fontSize: 24,
    fontWeight: 'normal',
  },
  balancePriceText: {
    color: '#263238',
    fontSize: 12,
    fontWeight: 'normal',
    marginTop: theme.spacing(0.5),
  },
  radioItem: {
    border: '1px solid #dfdfdf',
    borderRadius: 8,
    padding: theme.spacing(1),
    boxSizing: 'border-box',
    display: 'block',
    marginInlineEnd: theme.spacing(0),
    marginInlineStart: 0,
    transition: "all .1s ease-in",
    '&.active': {
      background: '#eceff1',
      borderColor: '#2B3990'
    },
  },
  radioIcon: {
    color: '#2b3990',
    fontSize: 25,
    display: 'inline-block',
    marginBottom: -8.5,
    marginInlineEnd: theme.spacing(1),
  },
  radioText: {
    color: '#2b3940',
    fontSize: 14,
    textOverflow: 'ellipsis',
    overflowWrap: 'break-word',
    whiteSpace: 'nowrap',
    maxWidth: 'calc(100% - 80px)',
    overflow: 'hidden',
    display: 'inline-flex',
  },
  radioCircle: {
    color: '#78909c',
  },
  dangerBox: {
    marginBottom: theme.spacing(0),
    backgroundColor: '#ffebee',
    borderRadius: '4px',
    border: 'solid 1px #ef9a9a',
    boxShadow: 'none',
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(2),
  },
  infoIcon: {
    fontSize: '20px',
    marginBottom: theme.spacing(-0.8),
    marginInlineStart: theme.spacing(1),
    color: theme.palette.grey[500],
    cursor: 'pointer',
  },
  dangerText: {
    fontSize: 14,
  },
  dangerIcon: {
    color: '#ff5500',
    marginInlineEnd: theme.spacing(1),
  },
  dangerLink: {
    color: '#ff5500',
  },
  bulkFileTitle: {
    fontWeight: 500,
    color: theme.palette.grey[700],
    marginTop: theme.spacing(1),
    '& a': {
      fontSize: 12,
      marginInlineStart: theme.spacing(1),
      color: theme.palette.primary.main,
      background: theme.palette.primary.light,
      padding: theme.spacing(0.5, 1.5),
      borderRadius: 20,
    },
  },
  bulkFileIcon: {
    color: theme.palette.grey[700],
    fontSize: 20,
    marginBottom: -6,
    marginInlineStart: theme.spacing(1),
    marginInlineEnd: theme.spacing(1),
  },
  optionsTitle: {
    fontWeight: 'bold',
    marginTop: theme.spacing(1),
    fontSize: 14,
  },
}));

export const useStylesSelectedOption = makeStyles((theme) => ({
  root: {
    background: '#b3e5fc',
    borderRadius: 20,
    padding: theme.spacing(0.5),
    display: 'inline-block',
    marginInlineStart: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  title: {
    fontSize: 12,
    color: '#003663',
    marginInlineStart: theme.spacing(1),
  },
  icon: {
    color: '#5f90af',
    padding: 4,
    marginInlineStart: theme.spacing(1),
  },
  iconTxt: {
    fontSize: 17,
  },
}));

export const useStylesUploadDoc = makeStyles((theme) => {
  return {
    uploadPaper: {
      position: 'relative',
      marginInlineStart: '8px',
      background: theme.palette.grey[100],
      border: `1px dotted ${theme.palette.primary.light}`,
      padding: theme.spacing(4),
      boxSizing: 'border-box',
      borderRadius: 10,
      cursor: 'pointer',
      transform: 'scale(1)',
      width: '100%',
      marginInlineEnd: theme.spacing(1),
      overflow: 'hidden',
      transition: 'ease .2s transform,ease .2s border',
      '&:hover': {
        borderColor: theme.palette.grey[700],
      },
      '&:active': {
        transform: 'scale(.98)',
      },
      '& *': {
        outline: 'none',
      },
    },
    dragHereIcon: {
      fontSize: 50,
      color: theme.palette.grey[600],
    },
    dragHereText: {
      paddingTop: theme.spacing(2),
      color: theme.palette.grey[600],
      fontFamily: 'Vazir',
    },
    fileFormat: {
      direction: 'rtl',
      fontSize: 40,
      marginBottom: 13,
      marginTop: 13,
      color: theme.palette.grey[600],
    },
    backdrop: {
      opacity: '0.4 !important',
    },
  };
});